// Progress bar for page scroll
const progress = document.querySelector('.js-page-scroll-progress');
// Find thge target element
const target = document.querySelector('.js-page-scroll-progress__target') || document.body;
// Cache the window scroll position
const cache = {
  y: 0,
  height: 0,
  offsetTop: 0
};

// Create a resize observer to update the target element height and offsets
const Observer = new ResizeObserver(() => {
  cache.height = target.scrollHeight;
  cache.offsetTop = Meteora.offset(target).y;
});

// Update the progress bar using requestAnimationFrame
const updateProgress = () => {
  window.requestAnimationFrame(() => {
    if (window.scrollY !== cache.y) {
      // Update the cache
      cache.y = window.scrollY;
      console.log(cache.offsetTop);
      // Update the progress bar
      // Using the cache.y, cache.height and cache.offsetTop and window.innerHeight values we can calculate the progress
      const percent = (cache.y + window.innerHeight * .5 - cache.offsetTop) / (cache.height - window.innerHeight * .5);
      // Round to 2 decimal places
      const percentRounded = Math.round(percent * 1000) / 1000;
      // Set the progress bar scale
      progress.style.transform = `scaleX(${percentRounded})`;
    }

    // Keep updating the progress bar
    updateProgress();
  });
};

// Observe the target element
Observer.observe(target);

// Update the progress bar on scroll
updateProgress();